import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-run',
  templateUrl: './run.component.html',
  styleUrls: ['./run.component.scss']
})
export class RunComponent implements OnInit {

  @Input() jobId: number;

  constructor() {
  }

  ngOnInit(): void {
  }

}
